import { render, staticRenderFns } from "./SettingsInstallationItem.vue?vue&type=template&id=42d54c25&scoped=true"
import script from "./SettingsInstallationItem.vue?vue&type=script&lang=ts"
export * from "./SettingsInstallationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d54c25",
  null
  
)

export default component.exports